/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ki_Feedback_Loading_HintInputs */

const en_ki_feedback_loading_hint = /** @type {(inputs: Ki_Feedback_Loading_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note: The analysis may take a moment. Please be patient.`)
};

const de_ki_feedback_loading_hint = /** @type {(inputs: Ki_Feedback_Loading_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinweis: Die Auswertung kann einen Moment dauern. Bitte hab etwas Geduld.`)
};

/**
* | output |
* | --- |
* | "Note: The analysis may take a moment. Please be patient." |
*
* @param {Ki_Feedback_Loading_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ki_feedback_loading_hint = /** @type {((inputs?: Ki_Feedback_Loading_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ki_Feedback_Loading_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ki_feedback_loading_hint(inputs)
	return en_ki_feedback_loading_hint(inputs)
});